import React from 'react';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import EnhancedTableHead from '../../utils/EnhancedTableHead';
import { commonTablestyles } from '../../utils/Style';
import ReactTable from 'react-table';
import '../../css/react-table/react-table.css';
import { MAPCLIENT_URL_DOMAIN } from "../../utils/constants";
import Navlink from "../../components/wrappers/Navlink";
import Uploader from '../../components/Uploader';



const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        
        marginRight: "auto",
        color: "green"
    }
});
class PlantationTable extends React.Component {
    
    constructor(props, context) {
        super(props, context);
        this.state = { 
            selected: [],
            data:this.props.data,
            order: 'asc',
            orderBy: '',
            page: 0,
            editedData:[],
            cid:this.props.cid,
            pid:-1,
        };
        this.renderEditable = this.renderEditable.bind(this);
        this.handlePid = this.handlePid.bind(this);
        this.uploadgeom = this.props.uploadgeom.bind(this);
        this.handleEditedContent = this.props.handleEditedContent.bind(this); 
    }

    
     
    renderEditable(cellInfo) {  
        return (
          <div
            style={{ backgroundColor: "#fafafa" }}
            contentEditable
            suppressContentEditableWarning
            onBlur={e => {
              const data = [...this.state.data];
              data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
              const editedData_ = [...this.state.editedData];
              editedData_.push(data[cellInfo.index])
              this.setState({editedData:editedData_  });
            }}
            dangerouslySetInnerHTML={{
             __html: this.state.data[cellInfo.index][cellInfo.column.id]
            }}
          />
        );
      }
      

    componentDidUpdate(prevProps,prevState){
        if(prevState.editedData !== this.state.editedData){  
              this.handleEditedContent(this.state.editedData);

        }
    }

    componentDidMount(){
        for(var i in this.uploadObj){

            this.uploadObj[i].manuallyChooseFile();
        }
    }

    uploaderProps =  {
        action: '', 
        headers: { 
        },
        multiple: true,
        beforeUpload(file) {
          console.log('beforeUpload', file.name);
        },
        onStart: (file) => {
          console.log('onStart', file.name);
          // this.refs.inner.abort(file);
        },
        onSuccess(file) {
          console.log('onSuccess', file);
        },
        onProgress(step, file) {
          console.log('onProgress', Math.round(step.percent), file.name);
        },
        onError(err) {
          console.log('onError', err);
        },
      };
    
    static getDerivedStateFromProps(props, state) {
        let update = {};
 
        //this.setState({ page: nextProps.page }); 
        if (props.data !== state.data) {
            update.data= props.data;
        }

        return update;
    }

    
    renderReactTable(data,classes,columns){
        return (
            <Paper>
            <Grid container className={classes.root}>
                    <Grid item xs={12}>
                            <Grid container justify='center' alignItems='center'>
                                Plantation List

                            </Grid>
                            <Grid container justify='center' alignItems='center'>
                                <ReactTable 
                                    className="-striped -highlight"
                                    defaultPageSize={10}
                                    data={ data}
                                    columns={columns}
                                    style={{width:'98%'}}
                                >

                                </ReactTable>

                            </Grid>
                    </Grid>
                    </Grid>
                     
            </Paper>
        );
    }

    handlePid=(value) =>{
        console.log('pid: ', value);
        this.setState({
            pid:value
        })
    }

    render() {
        
        const columns = [
            {
                
                "Header": "ID",
                Cell : props => props.index + 1
            },
            {
                
                "Header": "UID",
                "accessor": 'id', 
                show:false,
            }, 
            {
                "Header": 'Company Group',
                "accessor": 'company_group', 
            },
            {
                "Header": 'Company Name',
                "accessor": 'company_name', 
            },
            {
                "Header": 'Plantation Name',
                "accessor": 'plantation_name', 
            },
             
            {
                "Header": 'State',
                "accessor": 'state_name', 
            },
            {
                "Header": 'Province',
                "accessor": 'province_name', 
            },
            {
                "Header": 'Site',
                "accessor": 'site', 
            },
            {
                "Header": 'Mill',
                "accessor": 'mill', 
            },
            {
                "Header": 'Member Number',
                "accessor": 'member_num', 
            },
            {
                "Header": 'Cert Number',
                "accessor": 'certnum', 
            },
            {
                "Header": 'Area',
                "accessor": 'area', 
            },  
            {
                "Header": 'Actions', 
                minWidth:300,
                Cell: props => 
                 
                    <div>
                <Button style={{ marginLeft: '10px' }}     variant="contained" color="secondary" className={classes.button}  >
                    <Navlink style={{ color: '#fff' }} color="primary" variant="contained"  to={'//' + MAPCLIENT_URL_DOMAIN+'/app/index.html?k=' + localStorage.apiKey+ '&ses='+ localStorage.sessionKey+ '&mt=3&pid='+props.row.id}  target='_blank'>
                        <i className="fas fa-chart-line classes.heading" />Show on Map
                    </Navlink>
                </Button> <br/>
                <Uploader buttonText='Upload Geometry' uploadgeom={this.uploadgeom} pid={props.row.id}></Uploader>
          </div> 

            },
        ]

        
        const { classes, columnData, handleChangeRowsPerPage, handleModalOpen, handleChangePage, countuserValue, rowsPerPage, emptyRows, selected, handleClick, handleSelectAllClick } = this.props;
        const { objects, order, orderBy, page,data } = this.state;
        return (
           
        this.renderReactTable( data, classes,  columns)
        ); 
    }
}
export default withStyles(commonTablestyles)(PlantationTable);


// WEBPACK FOOTER //
// ./src/utils/MainTable/PlantationsTable.js